// extracted by mini-css-extract-plugin
export default {"invitation-details__content":"InvitationDetails_invitation-details__content__gvpq5"};